import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustSignals from './components/TrustSignals';
import ValueProposition from './components/ValueProposition';
import LeadForm from './components/LeadForm';
import CallToAction from './components/CallToAction';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img
            src="https://static.readdy.ai/image/aabcc23d397a531ae9f0b17792c65834/868837240d340ef158720fe61bab18b5.png"
            alt="Auto Transport Logo"
            className="h-12 w-auto"
          />
          <div className="flex items-center gap-6">
            <a
              href="tel:3058719862"
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              <i className="ri-phone-line mr-2"></i>
              (305) 871-9862
            </a>
            <a
              href="#quote"
              className="bg-orange-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </a>
          </div>
        </div>
      </nav>

      <Hero />
      <TrustSignals />
      <ValueProposition />
      <LeadForm />
      <Testimonials />
      <CallToAction />
      <Footer />
    </div>
  );
}